import React from 'react';
import { ShieldCheckIcon, PlusIcon, MoreVerticalIcon, MailIcon, ClockIcon } from 'lucide-react';
export function AdminUserModule({
  role
}: {
  role: string;
}) {
  const admins = [{
    id: 'ADM-001',
    name: 'Obinna Ukachukwu',
    email: 'obinna@skydd.com',
    role: 'Super Admin',
    lastLogin: '2026-03-30 14:30',
    status: 'Active'
  }, {
    id: 'ADM-002',
    name: 'Adewale O.',
    email: 'adewale@skydd.com',
    role: 'Ops Manager',
    lastLogin: '2026-03-30 09:15',
    status: 'Active'
  }, {
    id: 'ADM-003',
    name: 'Sarah Johnson',
    email: 'sarah@skydd.com',
    role: 'Claims Officer',
    lastLogin: '2026-03-29 16:00',
    status: 'Active'
  }, {
    id: 'ADM-004',
    name: 'Michael T.',
    email: 'michael@skydd.com',
    role: 'Support Agent',
    lastLogin: '2026-03-28 10:45',
    status: 'Active'
  }, {
    id: 'ADM-005',
    name: 'Jane Doe',
    email: 'jane@skydd.com',
    role: 'Support Agent',
    lastLogin: '2025-12-15 11:20',
    status: 'Deactivated'
  }];
  return <div className="space-y-6" data-id="element-81">
      <div className="flex justify-between items-center" data-id="element-82">
        <div data-id="element-83">
          <h2 className="text-2xl font-bold text-[#0D3B3B]" data-id="element-84">
            Admin User Management
          </h2>
          <p className="text-sm text-gray-500" data-id="element-85">
            Manage admin accounts and role-based access control.
          </p>
        </div>
        <button className="bg-[#0D3B3B] text-white px-4 py-2 rounded-xl font-bold text-sm flex items-center gap-2 hover:bg-[#092D2D] transition-colors shadow-lg shadow-emerald-900/20" data-id="element-86">
          <PlusIcon className="w-4 h-4" data-id="element-87" /> Create Admin
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-88">
        {admins.map(admin => <div key={admin.id} className={`bg-white rounded-2xl border shadow-sm p-6 transition-all ${admin.status === 'Deactivated' ? 'border-gray-200 opacity-75' : 'border-gray-100 hover:shadow-md'}`} data-id="element-89">
            <div className="flex justify-between items-start mb-4" data-id="element-90">
              <div className={`w-12 h-12 rounded-xl flex items-center justify-center font-bold text-lg ${admin.status === 'Deactivated' ? 'bg-gray-100 text-gray-400' : 'bg-[#0D3B3B] text-white'}`} data-id="element-91">
                {admin.name.split(' ').map(n => n[0]).join('')}
              </div>
              <span className={`px-2.5 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider ${admin.status === 'Active' ? 'bg-emerald-100 text-emerald-700' : 'bg-gray-100 text-gray-500'}`} data-id="element-92">
                {admin.status}
              </span>
            </div>

            <h3 className="font-bold text-[#0D3B3B] text-lg mb-1" data-id="element-93">
              {admin.name}
            </h3>
            <div className="flex items-center gap-2 text-sm text-gray-500 mb-4" data-id="element-94">
              <MailIcon className="w-4 h-4" data-id="element-95" />
              <span className="truncate" data-id="element-96">{admin.email}</span>
            </div>

            <div className="bg-gray-50 rounded-xl p-3 mb-4" data-id="element-97">
              <div className="flex justify-between items-center mb-2" data-id="element-98">
                <span className="text-[10px] uppercase font-bold text-gray-400 tracking-wider" data-id="element-99">
                  Role
                </span>
                <span className="text-xs font-bold text-[#0D3B3B] flex items-center gap-1" data-id="element-100">
                  <ShieldCheckIcon className="w-3.5 h-3.5 text-[#2BA89D]" data-id="element-101" />
                  {admin.role}
                </span>
              </div>
              <div className="flex justify-between items-center" data-id="element-102">
                <span className="text-[10px] uppercase font-bold text-gray-400 tracking-wider" data-id="element-103">
                  Last Login
                </span>
                <span className="text-xs font-medium text-gray-600 flex items-center gap-1" data-id="element-104">
                  <ClockIcon className="w-3.5 h-3.5" data-id="element-105" />
                  {admin.lastLogin}
                </span>
              </div>
            </div>

            <div className="flex gap-2" data-id="element-106">
              <button disabled={admin.status === 'Deactivated'} className="flex-1 bg-gray-50 hover:bg-gray-100 text-[#0D3B3B] font-bold py-2 rounded-lg text-xs transition-colors border border-gray-200 disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-107">
                Edit Role
              </button>
              <button disabled={admin.status === 'Deactivated'} className="flex-1 bg-gray-50 hover:bg-gray-100 text-[#0D3B3B] font-bold py-2 rounded-lg text-xs transition-colors border border-gray-200 disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-108">
                Reset Password
              </button>
              <button className="p-2 bg-gray-50 hover:bg-gray-100 text-gray-500 rounded-lg border border-gray-200 transition-colors" data-id="element-109">
                <MoreVerticalIcon className="w-4 h-4" data-id="element-110" />
              </button>
            </div>
          </div>)}
      </div>
    </div>;
}